package user.components

import antd.KeyboardEvent
import antd.MouseEvent
import antd.button.button
import antd.datepicker.datePicker
import react.*
import antd.form.form
import antd.form.formItem
import antd.input.input
import antd.grid.row
import antd.grid.col
import antd.message.message
import antd.select.SelectComponent
import antd.select.option
import antd.select.select
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.data.type.Date
import com.jingfangpai.common.orm.mapping.enums.UserSex
import kotlinext.js.js
import kotlinext.js.jsObject
import kotlinx.browser.localStorage
import kotlinx.browser.window
import user.containers.LoginPageContext
import org.w3c.dom.events.Event
import org.w3c.dom.HTMLInputElement
import react.dom.*
import urlBase
import user.containers.RegisterPageContext
import moment.moment

external interface  RegisterState:RState {
    var userName:String// = ""
    var sex:UserSex
    var birthday: Date?
    var mobilePhone:String
    var account:String
    var password:String// = ""
    var height :Int// = 600
    var width:Int// = 800
}

external interface RegisterComponentProps:RProps {
    var registerCallback:(userName:String,sex:UserSex,birthday:Date?,mobilePhone:String,account:String,password:String)->Unit
    var onTyping:()->Unit
}

@JsExport
class RegisterComponent : RComponent<RegisterComponentProps, RegisterState>() {
    init {
        //state = LoginState()
        state.userName = ""
        state.mobilePhone = ""
        state.account = ""
        state.password = ""
        state.height = 600
        state.width = 800
    }
    override fun componentDidMount() {

        setState{
            width  = window.innerWidth
            height = window.innerHeight
        }
        window.addEventListener("resize", ::updateWindowDimensions)
    }

    fun updateWindowDimensions(event:Event) {
        setState{
            width  = window.innerWidth
            height = window.innerHeight
        }
    }

    fun onSubmit(event: MouseEvent<Any>?){
        console.log("submiting...",state.userName,state.sex,state.birthday,state.mobilePhone,state.account,state.password)
        props.registerCallback(state.userName,state.sex,state.birthday,state.mobilePhone,state.account,state.password);
    }

    fun onKeyPress(event: KeyboardEvent<HTMLInputElement>){
        if (event.which == 13 || event.key == "Enter") {
            // Cancel the default action, if needed
            event.preventDefault();
            //trigger submit
            onSubmit(null)
        }
    }

    override fun RBuilder.render() {
        RegisterPageContext.Consumer { errorMsg ->

            console.log("consumer received",errorMsg)

            if (!errorMsg.isBlank()){
                message.error("注册失败：$errorMsg")
            }

            div{
                attrs {
                    jsStyle = js{margin = "0";padding="0"}
                }
                div("register-header") {
                    attrs {
                        jsStyle = js {
                            width = "${state.width}px"
                            height = "80px"
                            lineHeight = "80px"
                        }
                    }
                    p{
                        attrs{
                            jsStyle = js{
                                textAlign = "center"
                            }
                        }

                        h2{
                            attrs{
                                jsStyle {
                                    color = "white"
                                }
                            }
                            +"经方派　　"
                        }

                    }
                }

                div {
                    attrs {
                        jsStyle = js {
                            position = "relative"
                            width = "${state.width}px"
                            height = "600px"
                            //backgroundImage = "url('${urlBase}/images/login/login_bg.png')"
                        }
                    }
                    div {
                        attrs{
                            jsStyle = js{
                                width = "80%"
                                //height = "400px"
                                position = "absolute"
                                top = "50%"
                                left = "50%"
                                transform = "translate(-50%, -50%)"
                                textAlign = "center"
                            }
                        }
                        row {
                            col {
                                attrs {
                                    span = "3"
                                }
                            }
                            col {
                                attrs {
                                    span = "8"
                                    style = js{
                                        backgroundImage = "url('${urlBase}/images/login/login_decorate.png')"
                                    }
                                }
                            }
                            col {
                                attrs {
                                    span = "2"
                                }
                            }
                            col {
                                attrs {
                                    span = "8"
                                    style = js{
                                        background = "white"
                                        padding = "30px"
                                    }
                                }

                                form {
                                    attrs {
                                        name = "login"
                                        labelCol = jsObject {
                                            span = "3"
                                            pull = "left"
                                        }
                                    }

                                    formItem {
                                        attrs {
                                            label = "姓名"
                                        }
                                        input {
                                            attrs {
                                                value = state.userName
                                                name = "userName"
                                                size = "large"
                                                placeholder = "请输入用户名"
                                                onChange = {event: Event ->
                                                    props.onTyping()
                                                    val _u = js("event.target.value")
                                                    setState{userName = _u}
                                                }
                                            }
                                        }
                                    }
                                    formItem {
                                        attrs {
                                            label = "性别"
                                        }
                                        select<String, SelectComponent<String>> {
                                            attrs {
                                                value = state.sex?.getLiteral()
                                                onChange = { value: String, option: Any ->
                                                    setState{
                                                        sex = UserSex.valueOf(value)
                                                    }
                                                }
                                            }
                                            arrayOf(
                                                CascadedOption("男", UserSex.男),
                                                CascadedOption("女", UserSex.女),
                                            ).forEach {
                                                option {
                                                    attrs {
                                                        value = it.value?.getLiteral()
                                                    }
                                                    +it.label
                                                }
                                            }
                                        }
                                    }
                                    formItem {
                                        attrs {
                                            label = "出生日期"
                                        }
                                        datePicker {
                                            attrs {
                                                format = "YYYY-MM-DD"
                                                value = if (state.birthday != null) moment(state.birthday!!.toDateString()) else null
                                                onChange = { date, dateString ->
                                                    if(dateString.isBlank()){
                                                        setState{birthday=null}
                                                    }else {
                                                        setState{birthday=Date(dateString)}
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    formItem {
                                        attrs {
                                            label = "联系电话"
                                        }
                                        input {
                                            attrs {
                                                value = state.mobilePhone
                                                name = "mobilePhone"
                                                size = "large"
                                                placeholder = "请输入联系电话"
                                                onChange = {event: Event ->
                                                    props.onTyping()
                                                    val _u = js("event.target.value")
                                                    setState { mobilePhone = _u }
                                                }
                                            }
                                        }
                                    }
                                    formItem {
                                        attrs {
                                            label = "登录账号"
                                        }
                                        input {
                                            attrs {
                                                value = state.account
                                                name = "account"
                                                size = "large"
                                                placeholder = "请输入登录账号,建议使用手机号"
                                                onChange = {event: Event ->
                                                    props.onTyping()
                                                    val _u = js("event.target.value")
                                                    setState{account = _u}
                                                }
                                            }
                                        }
                                    }
                                    formItem {
                                        attrs {
                                            label = "密码"
                                        }
                                        input {
                                            attrs {
                                                value = state.password
                                                name = "password"
                                                type = "password"
                                                size = "large"
                                                placeholder = "请输入密码"
                                                onChange = {event: Event ->
                                                    props.onTyping()
                                                    setState{password = js("event.target.value")}
                                                }
                                                onKeyPress = ::onKeyPress
                                            }
                                        }
                                    }
                                    formItem {
                                        attrs {
                                            wrapperCol = jsObject {
                                                span = "20"
                                                offset = "18"
                                            }
                                        }
                                        button {
                                            attrs {
                                                type = "primary"
                                                onClick = ::onSubmit
                                            }
                                            +"注册"
                                        }
                                    }
                                }

                            }
                            col {
                                attrs {
                                    span = "3"
                                }
                            }
                        }
                    }
                }

            }
        }
    }
}

fun RBuilder.registerComponent(registerCallback:(userName:String,sex:UserSex,birthday:Date?,mobilePhone:String,account:String,password:String)->Unit,onTyping:()->Unit) = child(RegisterComponent::class) {
    attrs.registerCallback = registerCallback
    attrs.onTyping = onTyping
}

